const colors = require('tailwindcss/colors');

module.exports = {
    theme: {
        extend: {
            colors: {
                primary: 'var(--color-primary)',
                'primary-inverse': 'var(--color-primary-inverse)',
                secondary: 'var(--color-secondary)',
                'secondary-inverse': 'var(--color-secondary-inverse)',
                tertiary: 'var(--color-tertiary)',
                'tertiary-inverse': 'var(--color-tertiary-inverse)',

                palette: {
                    'clr-2': 'var(--clr2, #00a0a0)',
                    'clr-6': 'var(--clr6, #868686)',
                    'clr-7': 'var(--clr7, #8c317f)',
                    border: 'var(--border_clr, #e5f1f1)',
                    box: 'var(--box_clr,    #f2f8f8)',
                    text: 'var(--text_clr,   #1e1e1c)',
                    light: 'var(--light_text, #868686)',
                },

                blueGray: colors.slate,
                trueGray: colors.neutral,
                coolGray: colors.gray,
                warmGray: colors.stone,
                red: colors.red,
                orange: colors.orange,
                yellow: colors.yellow,
                lime: colors.lime,
                green: colors.green,
                emerald: colors.emerald,
                teal: colors.teal,
                cyan: colors.cyan,
                lightBlue: colors.sky,
                blue: colors.blue,
                indigo: colors.indigo,
                violet: colors.violet,
                purple: colors.purple,
                fuchsia: colors.fuchsia,
                pink: colors.pink,
                rose: colors.rose,
            },
        },
        fontFamily: {
            roboto: ['Roboto', 'sans-serif'],
        },
    },

    plugins: [require('@tailwindcss/aspect-ratio'), require('@tailwindcss/typography'), require('@tailwindcss/forms')],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',

        // Snapshot seeders contain canvas-block HTML with inline Tailwind
        // classes (hero badges, accent boxes, etc.) — scan them so the JIT
        // emits those classes into the final CSS.
        __dirname + '/database/seeders/**/*.php',
    ],
};
